import Model from '@/models/Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Transaction extends Model {
  resource() {
    return 'transactions'
  }

  get status() {
    if (this.accepted) {
      return 'accepted'
    } else if (this.declined) {
      return 'declined'
    } else if (this.expired) {
      return 'expired'
    } else {
      return 'pending'
    }
  }

  get statusColor() {
    switch (this.status) {
      case 'accepted':
        return 'primary'
      case 'declined':
      case 'expired':
        return 'red'
      default:
        return 'warning'
    }
  }

  get toolName() {
    return this.details ? this.details.name : {}
  }

  get owner() {
    return this.tool ? this.tool.owner : {}
  }

  get ownerName() {
    return this.owner ? this.owner.full_name : {}
  }

  get ownerAvatar() {
    return this.owner
      ? this.owner.avatar_permanent_thumb_url || this.owner.avatar_permanent_url
      : {}
  }

  get renter() {
    return this.renter_details ? this.renter_details : {}
  }

  get renterName() {
    return this.renter_details ? this.renter_details.full_name : null
  }

  get fromDate() {
    return dayjs
      .utc(this.from)
      .local()
      .format('MMM DD, YYYY')
  }

  get toDate() {
    return dayjs
      .utc(this.to)
      .local()
      .format('MMM DD, YYYY')
  }

  get rentDate() {
    return this.fromDate + ' - ' + this.toDate
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
